import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import MDButton from "../../components/MDButton";
import {formatCurrency} from "../common/Utils";
import Grid from "@mui/material/Grid";

export default function ViewInvoiceModal({invoice, show, handleSave, handleClose}) {

  const [context, setContext] = useContext(AppContext);
  const [saving, setSaving] = useState(false);

  const styles = {
    container: {
      maxWidth: '600px',
      backgroundColor: '#ffffff',
      margin: 'auto',
      border: '1px solid #ddd',
      borderRadius: '5px',
      padding: '20px'
    },
    headerTitle: {
      color: '#333',
      marginBottom: '10px'
    },
    headerSubtitle: {
      textAlign: 'center',
      marginTop: 0,
      color: '#666'
    },
    divider: {
      border: 'none',
      borderTop: '2px solid #111',
    },
    customerTable: {
      width: '100%',
      marginBottom: '20px'
    },
    labelCell: {
      fontWeight: 'bold',
      color: '#333',
      padding: '4px 0'
    },
    valueCell: {
      color: '#555',
      padding: '4px 0'
    },
    itemsTable: {
      width: '100%',
      borderCollapse: 'collapse',
      border: '1px solid #eee'
    },
    headerRow: {
      backgroundColor: '#f2f2f2'
    },
    tableHeader: {
      border: '1px solid #eee',
      padding: '8px'
    },
    tableHeaderRight: {
      border: '1px solid #eee',
      padding: '8px',
      textAlign: 'right'
    },
    tableCell: {
      border: '1px solid #eee',
      padding: '8px'
    },
    totalTable: {
      width: '100%',
      marginTop: '20px'
    },
    subtotalLabel: {
      textAlign: 'right',
    },
    subtotalValue: {
      textAlign: 'right'
    },
    totalLabel: {
      textAlign: 'right',
      fontWeight: 'bold',
      borderTop: '1px solid #eee'
    },
    totalValue: {
      fontWeight: 'bold',
      borderTop: '1px solid #eee',
      textAlign: 'right'
    },
    footerText: {
      textAlign: 'center',
      color: '#888',
      fontSize: '13px',
      marginTop: '30px'
    },
    footerLink: {
      color: '#0066cc',
      textDecoration: 'none'
    },
    hiddenHelper: {
      display: 'none',
      whiteSpace: 'nowrap',
      font: '15px courier'
    }
  };

  const printInvoice = () => {
    const content = document.getElementById("invoice-main").innerHTML;
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; font-size:0.9rem; line-height:0.9rem; }
                                                      p{margin:0; padding:0; line-height:13px; font-size:12px;}
                                                      h1,h2,h3,h4,h5,h6{font-size:14px; margin:0; padding:0; line-height:15px}
                                                      .no-print { display: none !important; }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${content}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }
  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>

      <Modal.Header closeButton>
        <Modal.Title>View Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className={'col col-main'} xs={12}>
            <Container>

              <div style={styles.container} id="invoice-main">
                <Grid container>
                  <Grid item xs={6}>
                    <h5 style={styles.headerTitle}>
                      {invoice?.companyName}
                    </h5>
                  </Grid>
                  <Grid item xs={6}>
                    <h5 style={{
                      ...styles.headerTitle,
                      textAlign: 'right'
                    }}>
                      Invoice
                    </h5>
                    <p style={{
                      ...styles.headerTitle,
                      textAlign: 'right'
                    }}>
                      Order ID: {invoice.referenceId}
                    </p>
                  </Grid>
                </Grid>

                <hr style={styles.divider}/>

                <table style={styles.customerTable} cellSpacing="0" cellPadding="0">
                  <tbody>
                  <tr>
                    <td style={styles.valueCell}>
                      <b>Invoice To</b>
                      <br/>
                      <b>{invoice.customerName}</b>
                      <br/>
                      {invoice.customerEmail} | {invoice.customerPhone}
                    </td>
                  </tr>
                  </tbody>
                </table>

                <table style={styles.itemsTable} cellSpacing="0" cellPadding="6">
                  <thead>
                  <tr style={styles.headerRow}>
                    <th align="left" style={styles.tableHeader}>Item</th>
                    <th style={styles.tableHeaderRight}>Qty</th>
                    <th style={styles.tableHeaderRight}>Price</th>
                  </tr>
                  </thead>
                  <tbody>
                  {invoice?.invoiceGroup && <>
                    {invoice?.invoices?.map((inv, idx) => {
                      return (
                        <tr key={idx}>
                          <td style={styles.tableCell}>{inv?.inventoryItem?.name}</td>
                          <td align="center" style={styles.tableCell}>{inv.quantity || 1}</td>
                          <td align="right" style={styles.tableCell}>{formatCurrency(inv?.total)}</td>
                        </tr>
                      )
                    })}
                  </>}
                  {!invoice?.invoiceGroup &&
                    <tr>
                      <td style={styles.tableCell}>{invoice?.inventoryItem?.name}</td>
                      <td align="center" style={styles.tableCell}>1</td>
                      <td align="right" style={styles.tableCell}>{formatCurrency(invoice?.total)}</td>
                    </tr>
                  }
                  </tbody>
                </table>

                {invoice?.tipTypes?.length > 0 && <>
                  <div style={{
                    borderBottom: 'solid 2px #ccc',
                    marginTop: '8px',
                    paddingBottom: '12px',
                    textAlign: 'right'
                  }}>
                    <p className={'mt-4 mb-0'}><b>Tip Options</b></p>

                    {invoice?.tipTypes?.sort((a, b) => a.sortOrder - b.sortOrder).map((item, idx) => {
                      return (
                        <small key={idx}>
                          {idx === 0 ? '' : <span style={{
                            padding: '0 6px'
                          }}>|</span>}{item.tipPercentage}%: <b>{formatCurrency(item.tipAmount)}</b>
                        </small>
                      )
                    })
                    }
                  </div>
                </>
                }

                <table style={styles.totalTable} cellSpacing="0" cellPadding="6">
                  <tbody>

                  <tr>
                    <td style={styles.subtotalLabel}>Total:</td>
                    <td style={styles.subtotalValue}>{formatCurrency(invoice.total)}</td>
                  </tr>
                  {invoice.totalDiscounts > 0 &&
                    <tr>
                      <td style={styles.subtotalLabel}>Discounts:</td>
                      <td style={styles.subtotalValue}>({formatCurrency(invoice.totalDiscounts)})</td>
                    </tr>
                  }
                  <tr>
                    <td style={styles.subtotalLabel}>Tax:</td>
                    <td style={styles.subtotalValue}>{formatCurrency(invoice.calculatedTax + invoice.depositedTax)}</td>
                  </tr>


                  {invoice?.depositedAmount > 0 &&
                    <>
                      <tr>
                        <td style={styles.totalLabel}>Grand Total:</td>
                        <td style={styles.totalValue}>{formatCurrency(invoice?.depositedAmount + invoice?.subtotal + invoice.calculatedTax)}</td>
                      </tr>
                      <tr>
                        <td style={styles.subtotalLabel}>Payments:</td>
                        <td style={styles.totalValue}>({formatCurrency(invoice?.depositedAmount)})</td>
                      </tr>
                    </>
                  }

                  <tr>
                    <td style={styles.totalLabel}>Total:</td>
                    <td style={styles.totalValue}>{formatCurrency(invoice.amountDue)}</td>
                  </tr>

                  </tbody>
                </table>

                {invoice?.tipTypes?.length > 0 && <div style={{
                  borderBottom: 'solid 2px #ccc',
                  paddingBottom: '24px',
                  marginBottom: '12px'
                }}>
                  <Grid container spacing={1} className={'mt-4'}>
                    <Grid item xs={12}>
                      <h6>Gratuity & Authorization</h6>
                      <Grid container spacing={2}>
                        <div style={{
                          width: '50%',
                          display: 'inline-block'
                        }}>
                          <div style={{
                            padding: '12px'
                          }}>
                            Additional Gratuity
                            <br/>
                            <div style={{
                              width: '100%',
                              borderBottom: 'solid 2px #111',
                              lineHeight: '2.4rem'
                            }}>$
                            </div>
                          </div>
                        </div>

                        <div style={{
                          width: '50%',
                          display: 'inline-block'
                        }}>
                          <div style={{
                            padding: '12px'
                          }}>
                            New Total (if adding gratuity)
                            <br/>
                            <div style={{
                              width: '100%',
                              borderBottom: 'solid 2px #111',
                              lineHeight: '2.4rem'
                            }}>$
                            </div>
                          </div>
                        </div>

                      </Grid>

                      <Grid container spacing={2} style={{
                        marginTop: '12px'
                      }}>
                        <div style={{
                          width: '68%',
                          display: 'inline-block'
                        }}>
                          <div style={{
                            padding: '12px'
                          }}>
                            Cardholder Signature
                            <br/>
                            <div style={{
                              width: '100%',
                              borderBottom: 'solid 2px #111',
                              lineHeight: '2.4rem'
                            }}>&nbsp;
                            </div>
                          </div>
                        </div>

                        <div style={{
                          width: '32%',
                          display: 'inline-block'
                        }}>
                          <div style={{
                            padding: '12px'
                          }}>
                            Date
                            <br/>
                            <div style={{
                              width: '100%',
                              borderBottom: 'solid 2px #111',
                              lineHeight: '2.4rem'
                            }}>&nbsp;
                            </div>
                          </div>
                        </div>

                      </Grid>

                    </Grid>
                  </Grid>
                </div>
                }

                <p style={styles.footerText}>
                  If you have any questions, contact us at{' '}
                  <a href={'mailto:' + invoice?.companyContact} style={styles.footerLink}>
                    {invoice?.companyContact}
                  </a>.
                </p>

                <div style={styles.hiddenHelper}></div>
              </div>
            </Container>
          </Col>
        </Row>

      </Modal.Body>
      <Modal.Footer>
        <MDButton type="button" color="secondary" disabled={saving} onClick={() => {
          printInvoice()
        }}>
          Print
        </MDButton>
      </Modal.Footer>
    </Modal>
  );
}